import { useCallback, useRef, useState } from "react";

interface BlockPinInputProps {
  value: "latest" | bigint;
  onChange: (value: "latest" | bigint) => void;
  disabled?: boolean;
}

export function BlockPinInput({
  value,
  onChange,
  disabled,
}: BlockPinInputProps) {
  const isPinned = value !== "latest";
  const [inputText, setInputText] = useState(isPinned ? value.toString() : "");
  const inputRef = useRef<HTMLInputElement>(null);

  const handlePinClick = useCallback(() => {
    if (isPinned) {
      onChange("latest");
      setInputText("");
    } else {
      onChange(0n);
      setInputText("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
    }
  }, [isPinned, onChange]);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/[^0-9]/g, "");
      setInputText(raw);
      if (raw) {
        onChange(BigInt(raw));
      }
    },
    [onChange],
  );

  return (
    <div className="landing-options-section">
      <div className="landing-options-label">Fork Block</div>
      <div className="landing-chip-group">
        <button
          type="button"
          className="landing-chip"
          data-active={!isPinned || undefined}
          disabled={disabled}
          onClick={() => {
            onChange("latest");
            setInputText("");
          }}
        >
          Latest
        </button>
        <button
          type="button"
          className="landing-chip"
          data-active={isPinned || undefined}
          disabled={disabled}
          onClick={handlePinClick}
        >
          Pin:
        </button>
        {isPinned && (
          <input
            ref={inputRef}
            type="text"
            inputMode="numeric"
            value={inputText}
            onChange={handleInputChange}
            placeholder="block #"
            className="landing-input-sm"
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}
